import React, { memo, useState, Fragment, useEffect } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  Divider,
  IconButton,
  List,
  ListItem,
  ListSubheader,
  Tab,
  TextField,
  Typography,
  Checkbox,
  Tooltip
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import DefaultModal from "../DefaultModal";
import { LoadingButton, TabContext, TabList, TabPanel } from "@mui/lab";
import { DropableBox } from "../DropableBox";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

import {
  ArrowBackIos,
  ArrowDownward,
  ArrowDropDown,
  ArrowDropUp,
  ArrowUpward,
  Delete,
  Print,
  ReplayOutlined,
  Warning,
} from "@mui/icons-material";
import "./style.css";
import DefaultDropDown, {
  DefaultDropDownWithCheckBox,
} from "../DefaultDropdown";
import {
  buscarLogs,
  salvarLogs,
  deletarLog,
  getPreferenciasColunas,
  putPreferenciasColunas,
  buscarLogsPorId,
} from "../../Services";
import moment from "moment";
import { AutoSizer, List as ListVirtualized } from "react-virtualized";
import { maskCurrency } from "../../Utils";
import { useCotacao } from "../../hooks/useCotacao";
import { set } from "date-fns";

const relatorioColunas = [
  { name: "todos", checked: true, title: "Todas" },
  { name: "inseriruf", checked: true, title: "UF" },
  { name: "inserirdata", checked: true, title: "Data publicação" },
  { name: "inserirmedia", checked: true, title: "Média" },
  { name: "inserirmediana", checked: false, title: "Mediana" },
  { name: "inserirmenorValor", checked: false, title: "Menor valor" },
  { name: "inserirmaiorValor", checked: false, title: "Maior valor" },
  { name: "inserirvalorTotal", checked: true, title: "Valor total" },
  { name: "inserirfonte", checked: true, title: "Fonte" },
  { name: "inserirorgao", checked: true, title: "Orgão comprador" },
  { name: "inserirfornecedor", checked: true, title: "Fornecedor" },
  { name: "inseriritemdescricao", checked: true, title: "Descrição" },
  {
    name: "inseriritemdescricaodetalhada",
    checked: true,
    title: "Descrição detalhada",
  },
  { name: "inserirunidade", checked: true, title: "Unidade de medida" },
  { name: "inserirquantidade", checked: true, title: "Quantidade" },
  {
    name: "inserirquantidadecotacao",
    checked: true,
    title: "Minha quantidade",
  },
  { name: "inserirvalorUnitario", checked: true, title: "Valor unitário" },
  { name: "inserirvalorUnitarioAjustado", checked: false, title: "Valor unitário + IPCA" },
];

const Container = memo(function Container({
  data,
  setData,
  onRemove,
  scrollToIndex,
}) {
  const [todosSelecionados, setTodosSelecionados] = useState(false);
  const [selecionados, setSelecionados] = useState([]);
  const [ordenar, setOrdenar] = useState("Nenhum");
  const { cotacaoSelecionada, setCheckedItemCotacao } = useCotacao();
  console.log(data)
  const onRemoveItem = (i = [], _index) => {
    let _data = Object.assign([], data);

    _data[_index].itens = _data[_index].itens.filter(
      (j) => !i.some((k) => k._id === j._id)
    );

    const listaSalvar = _data.map((p) => ({
      ...p,
      itens: p.itens.map((x) => x._id),
    }));

    const body = {
      titulo: cotacaoSelecionada?.name,
      itens: listaSalvar,
      date: moment(),
    };

    salvarLogs(body, cotacaoSelecionada.id);

    for (const _ of i) {
      setCheckedItemCotacao({
        itemId: data[_index].id,
        add: false,
        remove: true,
      });
    }

    setData(_data);
  };

  const moveBox = (index, up = false) => {
    const _data = Object.assign([], data);
    const fromIndex = index;
    const toIndex = !up ? index + 1 : index - 1;
    const element = _data.splice(fromIndex, 1)[0];
    _data.splice(toIndex, 0, element);
    setData(_data);
  };

  const handleSort = (index, e) => {
    const _data = Object.assign([], data);
    if (e.id === 0) {
      _data[index].itens = _data[index].itens.sort(
        (a, b) => a.valorUnitario - b.valorUnitario
      );
    } else if (e.id === 1) {
      _data[index].itens = _data[index].itens.sort(
        (a, b) => b.valorUnitario - a.valorUnitario
      );
    }

    setData(_data);
  };

  const handleMove = (index, arr = [], id) => {
    const _data = Object.assign([], data);
    let newIndex = _data.findIndex((z) => z.id === id);
    let remover = [];

    for (let j = 0; j < arr.length; j++) {
      const e = arr[j];

      let a = _data[index].itens[e.index];
      remover.push(a);

      if (_data[newIndex].itens.findIndex((i) => i._id === a._id) === -1) {
        _data[newIndex].itens.push(a);
      }
    }

    _data[index].itens = _data[index].itens.filter(
      (i) => !remover.some((j) => j._id === i._id)
    );

    if (!_data[index].itens.length) {
      _data.splice(index, 1);
    }

    setData(_data);
  };

  const renderRow = ({ index, key, style }) => {
    const handleAll = (e) => {
      const { checked } = e.target;
      let _selecionados = [];
      const { itens } = data[index];

      if (checked) {
        _selecionados = itens.map((i, index) => ({
          _id: i._id,
          title: i.title,
          index: index,
        }));
        setSelecionados();
      }

      setSelecionados(_selecionados);
      setTodosSelecionados(
        _selecionados.length ? _selecionados.length === itens.length : false
      );
    };

    const handleSelect = (item, e, index) => {
      const { checked } = e.target;
      if (checked) {
        setSelecionados([...selecionados, { _id: item._id, index: index }]);
      } else {
        setSelecionados(selecionados.filter((i) => i._id !== item._id));
      }
    };

    const handleRemoveItem = () => {
      if (!selecionados.length) {
        return;
      }
      onRemoveItem(selecionados, index);
    };


    const ToolbarTable = ({ itens }) => {
      if (!itens || itens.length === 0) {
        return null;
      }
      const min = Math.min(...itens.map(i => i.valorUnitario));
      const max = Math.max(...itens.map(i => i.valorUnitario));
      const media = itens.reduce((acc, curr) => acc + curr.valorUnitario, 0) / itens.length;
      const sorted = [...itens].sort((a, b) => a.valorUnitario - b.valorUnitario);
      const mid = Math.floor(sorted.length / 2);
      const mediana = sorted.length % 2 !== 0 ? sorted[mid].valorUnitario : (sorted[mid - 1].valorUnitario + sorted[mid].valorUnitario) / 2;


      
    let diferencaMaiorMenorValorEmPorcentagem = min > 0 && max != min ? ((max - min) / min) * 100 : 0;


      return (
        <div
          style={{
            display: "flex",
            width: "100%",
            height: 26,
            justifyContent: "space-around",
            backgroundColor: "#cfd8dc",
            border: "1px solid #cfd8dc",
          }}
        >
          <Typography
            sx={{
              mr: 2,
              ml: 1,
              display: { xs: "none", md: "flex" },
              fontWeight: 600,
              letterSpacing: ".05rem",
              color: "inherit",
              textDecoration: "none",
              textAlign: "center",
            }}
            onClick={() => { console.log(itens) }}
          >
            Média:
            {maskCurrency(media)}
          </Typography>
          <Typography
            sx={{
              mr: 2,
              ml: 1,
              display: { xs: "none", md: "flex" },
              fontWeight: 600,
              letterSpacing: ".05rem",
              color: "inherit",
              textDecoration: "none",
              textAlign: "center",
            }}
          >
            Mediana:
            {maskCurrency(mediana)}
          </Typography>
          <Typography
            sx={{
              mr: 2,
              ml: 1,
              display: { xs: "none", md: "flex" },
              fontWeight: 600,
              letterSpacing: ".05rem",
              color: "inherit",
              textDecoration: "none",
              textAlign: "center",
            }}
          >
            Menor Valor:
            {maskCurrency(min)}
          </Typography>
          
             {diferencaMaiorMenorValorEmPorcentagem > 0 && (
              <Typography
            sx={{
              mr: 2,
              ml: 1,
              display: { xs: "none", md: "flex" },
              fontWeight: 600,
              letterSpacing: ".05rem",
              color: "inherit",
              textDecoration: "none",
              textAlign: "center",
            }}
          >
                <Tooltip 
                  title={`Este valor é ${diferencaMaiorMenorValorEmPorcentagem.toFixed(2)}% maior que o menor valor registrado.`} 
                  arrow
                >
                  <Box
                    component="span"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      ml: 1,
                      color: 'success.main', // Usa a cor de sucesso (verde) do tema
                      cursor: 'help', // Muda o cursor para indicar que tem info extra
                      fontSize: '0.875rem'
                    }}
                  >
                    <ArrowUpwardIcon fontSize="inherit" sx={{ mr: 0.5 }} />
                    {diferencaMaiorMenorValorEmPorcentagem.toFixed(2)}%
                  </Box>
                </Tooltip>
                          </Typography>
              )}

          <Typography
            sx={{
              mr: 2,
              ml: 1,
              display: { xs: "none", md: "flex" },
              fontWeight: 600,
              letterSpacing: ".05rem",
              color: "inherit",
              textDecoration: "none",
              textAlign: "center",
            }}
          >
            Maior Valor:
            {maskCurrency(max)}             
          </Typography>
        </div>
      )
    };

    const selecionadosNesteGrupo = data[index].itens.filter(item =>
      selecionados.some(sel => sel._id === item._id)
    );
    const itensParaCalculo = selecionadosNesteGrupo.length > 0
      ? selecionadosNesteGrupo
      : data[index].itens;



    return (
      <div
        key={key}
        style={{
          ...style,
          width: "98%",
          overflowY: "hidden",
        }}
        className="drop-container"
      >
        <div style={{ height: "40%" }}>
          <div style={{ display: "flex" }}>
            <Typography
              variant="overline"
              fontSize={14}
              style={{
                backgroundColor: "rgba(218, 165, 32, 0.73)",
                padding: "5px",
                borderRadius: "3px",
                textAlign: "justify",
                width: "100%",
                display: "block",
                margin: "6px",
                maxHeight: 70,
                overflow: "hiddens",
              }}
              color="InfoText"
            >
              {data[index].nome}
            </Typography>
            <div style={{ width: "8%", display: "flex" }}>
              {index !== data.length - 1 && (
                <Tooltip title="Mover quadro para baixo">
                  <IconButton size="small" onClick={() => moveBox(index)}>
                    <ArrowDownward />
                  </IconButton>
                </Tooltip>
              )}
              {index !== 0 && (
                <Tooltip title="Mover quadro para cima">
                  <IconButton onClick={() => moveBox(index, true)}>
                    <ArrowUpward />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          </div>

          {/* <Button
            color="error"
            className="remove-btn"
            onClick={() => handleRemoveAll(index)}
          >
            Excluir lista
          </Button> */}

          {data[index].itens.length ? (
            <div>
              <div
                style={{
                  paddingLeft: 16,
                  paddingRight: 16,
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 20,
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Checkbox checked={todosSelecionados} onChange={handleAll} />{" "}
                  <span style={{ marginRight: 30, fontSize: 16 }}>
                    <b>SELECIONAR TODOS:</b>
                  </span>
                  <DefaultDropDown
                    title="Mover para"
                    data={data.filter((i) => i.nome !== data[index].nome)}
                    onSelect={(e) => {
                      handleMove(index, selecionados, e.id);
                      setSelecionados([]);
                    }}
                  />
                  <Button
                    onClick={handleRemoveItem}
                    variant="outlined"
                    color="error"
                    style={{ marginLeft: 10 }}
                  >
                    Excluir
                  </Button>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 15,
                  }}
                >
                  <span>
                    <b>Ordenar por:</b>
                  </span>
                  <DefaultDropDown
                    variant="outlined"
                    title={`Ordenar por ${ordenar || "Nenhum"}`}
                    onSelect={(e) => {
                      handleSort(index, e);
                      setOrdenar(e.title);
                    }}
                    data={[
                      { title: "Nenhum", id: -1 },
                      { title: "Menor valor", id: 0 },
                      { title: "Maior valor", id: 1 },
                    ]}
                  />
                </div>
              </div>
              <ToolbarTable itens={itensParaCalculo} />
            </div>

          ) : null}


        </div>

        <List style={{ height: "60%", overflow: "scroll" }}>
          {data[index].itens.length > 0 &&
            data[index].itens.map((i, _index) => (
              <ListItem
                key={_index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: 14,
                }}
              >
                <div style={{ width: "85%" }}>
                  <Checkbox
                    onChange={(e) => handleSelect(i, e, _index)}
                    checked={selecionados.some((j) => j._id === i._id)}
                  />
                  <b style={{ marginRight: 8 }}>{_index + 1}.</b>
                  {i.fornecedor.fornecedor_razao_social} / {i.descricao_item} -{" "}
                  {maskCurrency(i.valorUnitario)} {i.valorUnitarioAjustado ? <span style={{fontSize: 11, fontStyle: "italic"}}>(IPCA: ${maskCurrency(i.valorUnitarioAjustado.toFixed(2))})</span> : ""}
                </div>
                <div style={{ width: "15%" }}>
                  <span>Quantidade do pregão: {i.quantidade_item}</span>
                  <br />
                  <span>Quantidade da cotação: {data[index].quantidade}</span>
                  {/* <TextField
                    label="Quantidade"
                    type="number"
                    value={i.quantidade_item}
                    onChange={(e) => onChangeQuantidade(e, _index, index)}
                    size="small"
                  /> */}
                </div>
              </ListItem>
            ))}
        </List>
      </div>
    );
  };

  return (
    <div
      style={{ clear: "both", marginRight: 30, width: "100%", height: "100%" }}
    >
      <AutoSizer>
        {({ width, height, style }) => (
          <ListVirtualized
            scrollToIndex={scrollToIndex}
            style={style}
            width={width}
            height={height}
            rowHeight={350}
            rowRenderer={renderRow}
            rowCount={data.length}
            overscanRowCount={1}
          />
        )}
      </AutoSizer>
    </div>
  );
});

const PrintList = ({
  data = [],
  open,
  onClose,
  onRemove,
  getPDF,
  getExcel,
  setData,
  loading,
  addNotification,
}) => {
  const [nome, setNome] = useState("");
  const [tab, setTab] = useState("1");
  const [acao, setAcao] = useState(null);
  const [tituloPesquisa, setTituloPesquisa] = useState("");
  const [pesquisasSalvas, setPesquisasSalvas] = useState([]);
  const [collapse, setCollapse] = useState(null);
  const [load, setLoad] = useState({
    print: false,
    save: false,
    delete: false,
    changetab: false,
    detalhesPesquisa: false,
    index: null,
  });
  const [logId, setLogId] = useState(null);
  const [nomePesquisaRetomada, setNomePesquisaRetomada] = useState("");
  const [colunasImpressao, setColunasImpressao] = useState(relatorioColunas);
  const [indexScroll, setindexScroll] = useState(data?.length - 1);
  const [mostrarValorNormal, setMostrarValorNormal] = useState(false);

  const handleTabChange = async (e, v) => {
    setLoad({ ...load, changetab: true });
    if (v === "2") {
      const res = await buscarLogs();
      if (res.success) {
        setPesquisasSalvas(res.data);
      }
    }
    setTab(v);
    setLoad({ ...load, changetab: false });
  };

  const handleChange = (e) => {
    if (acao === 2) {
      setNomePesquisaRetomada(e.target.value);
    } else {
      setTituloPesquisa(e.target.value);
    }
  };

  const handleSave = async () => {
    const titulo = acao === 1 ? tituloPesquisa : nomePesquisaRetomada;

    if (!titulo) {
      addNotification("Adicione um título para sua pesquisa!", true, "info");
      return;
    }

    let _data = Object.assign([], data);
    _data = _data.map((i) => ({
      nome: i.nome,
      itens: i.itens.map((j) => ({
        _id: j._id,
        quantidade: j.quantidade_item,
      })),
    }));

    const body = { titulo: titulo, itens: _data, date: moment() };

    setLoad({ ...load, save: true });
    const _id = logId && acao === 2 ? logId : null;
    const res = await salvarLogs(body, _id);
    setLoad({ ...load, save: false });

    if (res.success) {
      setAcao(null);
      setTituloPesquisa("");
      addNotification("Pesquisa salva com sucesso", true, "success");
    } else {
      addNotification(res.msg, true, "error");
    }
  };

  const handleAcao = (id) => {
    if (id < 3) {
      setAcao(id);
    } else {
      setLogId(null);
      setData([]);
    }
  };

  const imprimirPesquisaSalva = async (index) => {
    if (load.index) {
      return;
    }
    const itens = pesquisasSalvas[index]?.pesquisas;

    if (itens) {
      setLoad({ ...load, print: true, index: index });
      await getPDF(itens, "*****", null, pesquisasSalvas[index]?.titulo);
      setLoad({ ...load, print: false, index: null });
    }
  };

  const handleDeleteLog = async (id, index) => {
    setLoad({ ...load, delete: true, index: index });
    const res = await deletarLog(id);
    setLoad({ ...load, delete: false, index: null });

    if (res.success) {
      let itens = pesquisasSalvas.filter((i, _index) => index !== _index);
      setPesquisasSalvas(itens);
    }
  };

  const handleRetomar = (index, i) => {
    setData(
      pesquisasSalvas[index].pesquisas.map((i, index) => ({
        ...i,
        id: Date.now() + index,
      }))
    );
    setLogId(i.id);
    setNomePesquisaRetomada(i.titulo);
    addNotification("Pesquisa retomada com sucesso!", true, "success");
    setTab("1");
  };

  const buscarPreferencias = async () => {
    if (open) {
      const t = sessionStorage.getItem("titulo-cotacao") || "";

      setTituloPesquisa(t);
      setNomePesquisaRetomada(t);

      const res = await getPreferenciasColunas();
      console.log(res);
      if (res.success) {
        const item = relatorioColunas.map((p) => ({
          ...p,
          checked: res.data[p.name] ?? false,
        }));

        setColunasImpressao(item);
      }
    }
  };

  const handleCheck = async (e) => {
    let _itens = [...colunasImpressao];

    if (_itens[e.index].name === "todos") {
      _itens = _itens.map((i) => ({
        ...i,
        checked: !e.checked,
      }));

    } else {

      if (e.name == 'inserirmaiorValor' || e.name == 'inserirmenorValor' || e.name == 'inserirmedia' || e.name == 'inserirmediana') {
        const legendasSelecionadas = _itens.filter(i => (i.name === 'inserirmaiorValor' || i.name === 'inserirmenorValor' || i.name === 'inserirmedia' || i.name === 'inserirmediana') && i.checked);
        _itens.forEach(i => {
          if (legendasSelecionadas.some(j => j.name === i.name) && e.name !== i.name) {
            i.checked = false;
          }
        })
      }

            if (e.name == 'inserirvalorUnitarioAjustado' || e.name == 'inserirvalorUnitario') {
        const legendasSelecionadas = _itens.filter(i => (i.name === 'inserirvalorUnitarioAjustado' || i.name === 'inserirvalorUnitario') && i.checked);
        _itens.forEach(i => {
          if (legendasSelecionadas.some(j => j.name === i.name) && e.name !== i.name) {
            i.checked = false;
          }
        })
      }

      

      _itens[e.index] = {
        ..._itens[e.index],
        checked: !_itens[e.index].checked,
      };

      _itens[0] = { ..._itens[0], checked: _itens.every((i) => i.checked) };

    }

    const body = {};

    _itens.forEach((p) => {
      body[p.name] = p.checked;
    });

    setColunasImpressao(_itens);

    await putPreferenciasColunas(body);
  };

  const buscarDetalhesPesquisa = async (id, index) => {
    let mostrar = index === collapse ? null : index;

    if (mostrar === index) {
      setLoad({ ...load, index, detalhesPesquisa: true });
      const res = await buscarLogsPorId(id);

      if (res.success) {
        const _data = [...pesquisasSalvas];

        _data[index] = res.data.data;
        setPesquisasSalvas(_data);

        setCollapse(mostrar);
      }

      setLoad({ ...load, index: null, detalhesPesquisa: false });
    } else {
      setLoad({ ...load, index: null, detalhesPesquisa: false });
      setCollapse(mostrar);
    }
  };

  useEffect(() => {
    buscarPreferencias();
  }, [open]);

  return (
    <DefaultModal
      open={open}
      title="IMPRESSÃO RE RELATÓRIOS"
      onClose={onClose}
      style={{ width: "90vw", height: "85vh" }}
      children={
        <TabContext value={tab}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleTabChange}>
              <Tab label="itens selecionados" value="1" />
              {/* <Tab
                label={
                  <span>
                    {load.changetab ? (
                      <CircularProgress size={14} style={{ marginRight: 10 }} />
                    ) : null}
                    Pesquisas salvas
                  </span>
                }
                value="2"
              /> */}
            </TabList>
          </Box>
          <TabPanel value="1">
            {data.length > 0 ? (
              <>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button onClick={() => setindexScroll(0)}>
                    Ir para o primeiro item
                  </Button>
                  <Button onClick={() => setindexScroll(data?.length - 1)}>
                    Ir para o último item
                  </Button>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <div className="styled-list">
                    <Container
                      data={data}
                      setData={setData}
                      onRemove={onRemove}
                      scrollToIndex={indexScroll}
                    />
                  </div>
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <TextField
                      fullWidth
                      label="Responsável"
                      size="small"
                      required
                      value={nome}
                      onChange={(e) => setNome(e.target.value)}
                      style={{ marginRight: 15 }}
                    // inputProps={{ maxLength: 50 }}
                    />
                    <TextField
                      fullWidth
                      value={nomePesquisaRetomada}
                      size="small"
                      label="Título da pesquisa"
                      onChange={(e) => setNomePesquisaRetomada(e.target.value)}
                      style={{ marginRight: 15 }}
                    // inputProps={{ maxLength: 70 }}
                    />
                    <DefaultDropDownWithCheckBox
                      title={"Colunas"}
                      data={colunasImpressao}
                      onSelect={handleCheck}
                    />
                    <LoadingButton
                      size="small"
                      loading={loading.pdf}
                      variant="contained"
                      style={{
                        backgroundColor: "#ff0000",
                        margin: 2,
                        width: 280,
                      }}
                      onClick={() => {
                        getPDF(
                          data,
                          nome,
                          colunasImpressao,
                          nomePesquisaRetomada
                        )
                      }
                      }
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          margin: 2,
                        }}
                      >
                        <PictureAsPdfIcon />
                        <span style={{ marginLeft: 3 }}>Exportar</span>
                      </span>
                    </LoadingButton>
                    <LoadingButton
                      loading={loading.xlxs}
                      size="small"
                      variant="contained"
                      style={{
                        backgroundColor: "#008000",
                        margin: 2,
                        width: 280,
                      }}
                      onClick={() => getExcel(data, nome)}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          margin: 2,
                        }}
                      >
                        <GridOnIcon />
                        <span style={{ marginLeft: 3 }}>Exportar</span>
                      </span>
                    </LoadingButton>
                  </Box>
                </div>
              </>
            ) : (
              <div className="img-container">
                <div className="no-data" />
                <Typography style={{ width: "70%" }}>
                  <Warning
                    style={{
                      color: "#FFCC00",
                      verticalAlign: "sub",
                      marginRight: 5,
                      fontSize: 25,
                    }}
                  />
                  Ops! Não há nenhum item selecionado, selecione algum item para
                  visualizar as opções de impressão.
                </Typography>
              </div>
            )}
          </TabPanel>
          <TabPanel value="2">
            <List sx={{ overflow: "auto", height: "70vh" }}>
              {pesquisasSalvas.map((i, index) => (
                <div key={index}>
                  <ListItem sx={{ justifyContent: "space-between" }}>
                    <Typography variant="body1">
                      {index + 1}. PESQUISA: {i.titulo} -{" "}
                      {moment(i.date).format("DD/MM/YYYY HH:mm:ss")}
                    </Typography>

                    <div>
                      {/* {i.pesquisas.length ? (
                        <>
                          <IconButton
                            title="Imprimir"
                            onClick={() => imprimirPesquisaSalva(index)}
                          >
                            {load.print && index === load.index ? (
                              <CircularProgress size={20} />
                            ) : (
                              <Print />
                            )}
                          </IconButton>
                          <IconButton
                            title="Retomar"
                            onClick={() => handleRetomar(index, i)}
                          >
                            <ReplayOutlined />
                          </IconButton>
                        </>
                      ) : null} */}
                      {/* <IconButton
                        title="Excluir"
                        onClick={() => handleDeleteLog(i.id, index)}
                      >
                        {load.delete && load.index === index ? (
                          <CircularProgress size={20} />
                        ) : (
                          <Delete />
                        )}
                      </IconButton> */}
                      <IconButton
                        title={collapse === index ? "Fechar" : "Abrir"}
                        onClick={() => buscarDetalhesPesquisa(i.id, index)}
                      >
                        {load.detalhesPesquisa && load.index === index ? (
                          <CircularProgress size={20} />
                        ) : collapse === index ? (
                          <ArrowDropUp />
                        ) : (
                          <ArrowDropDown />
                        )}
                      </IconButton>
                    </div>
                  </ListItem>
                  <Collapse in={collapse === index} sx={{ pl: 3 }}>
                    <List>
                      <Divider />
                      {i.pesquisas
                        ? i.pesquisas.map((j, jIndex) => (
                          <Fragment key={jIndex}>
                            <ListSubheader>
                              {index + 1}.{jIndex + 1} - {j.nome}
                            </ListSubheader>
                            {j.itens.map((k, kIndex) => (
                              <ListItem key={kIndex} sx={{ pl: 4 }} divider>
                                {index + 1}.{jIndex + 1}.{kIndex + 1} -{" "}
                                {k.descricao_detalhada_item}
                              </ListItem>
                            ))}
                          </Fragment>
                        ))
                        : null}
                    </List>
                  </Collapse>
                </div>
              ))}
            </List>
          </TabPanel>
        </TabContext>
      }
    />
  );
};

export default memo(PrintList);
